'use client';

var translations = {
    'Career Advice From HR Insider': 'Tư Vấn Nghề Nghiệp Từ HR Insider',
    'View all': 'Xem tất cả',
};

export { translations as default };
//# sourceMappingURL=translation.js.map
